import { AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { ModalService } from '../Services/modalService';

@Component({
	standalone: false,
	selector: 'public-modal',
	template: `
		<div [hidden]="!modalService.loadedComponent">
			<div class="modal__overlay" (click)="handleClick()"></div>
			<div class="modal">
				<div class="modal__container">
					<div class="cancel" (click)="handleClick()" *ngIf="modalService.canBeClosed">
						<visiba-svg a="X"></visiba-svg>
					</div>
					<ng-template #modalContainer></ng-template>
				</div>
			</div>
		</div>
	`,
	styleUrls: ['../Css/Components/modal.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ModalComponent implements AfterViewInit {
	@ViewChild('modalContainer', { static: false, read: ViewContainerRef })
	public entry: ViewContainerRef;

	constructor(public modalService: ModalService) {}

	ngAfterViewInit() {
		this.modalService.setViewContainerRef(this.entry);
	}

	public handleClick() {
		if (!this.modalService.canBeClosed) return;
		this.modalService.detach();
	}
}
